var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ml-2",attrs:{"color":"error","dark":"","label":"","small":""}},[_c('span',{staticClass:"white--text"},[_vm._v("DELETED")])])}
var staticRenderFns = []

export { render, staticRenderFns }